/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-07 13:26:02
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import {
  Modal,
  TextStyle,
  TextField,
  Scrollable,
  Button,
  Icon,
  ChoiceList
} from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MobileCancelMajor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { ADDONS_INFO_V4, DISCOUNT_ERRORS } from 'src/constants/subscription';
import {
  formatPriceDisplay,
  calculateBillingMonthly,
  getDiscountCodeValue
} from 'src/helpers/subscription-v3-helper';
import { routes } from 'src/routes';
import { exitSABFullscreen } from 'src/integrations/shopify-app-bridge/fullscreen';
import { connect } from 'react-redux';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleConfirm: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class ReviewPackageModal extends Component<ComposedProps> {
  state = {
    showDiscountCodeInput: false,
    addonList: [],
    addonAdded: [],
    invoice: {},
    code: '',
    preSelect: [],
    viewDiscountBreakdown: false
  };

  async componentDidMount() {
    const { invoice, packageNameType } = this.props;

    if (packageNameType === 'freemium') {
      this.setState({ addonList: [] });
      return;
    }
    const addonList = [...ADDONS_INFO_V4];
    // Build Addon list for package
    this.buildAddonList(addonList);

    // Init value state
    this.setState({
      addonList
    });

    // Init addon added
    const nextSubscribedAddOnsInfos = _.get(invoice, 'subscribedAddOnsInfos', []);
    await this.initAddonAdded(addonList, nextSubscribedAddOnsInfos);
  }

  componentWillReceiveProps(nextProps) {
    const { addonList } = this.state;

    const { addonsSuggestionBeta = [], gettingInvoice } = nextProps;

    const nextSubscribedAddOnsInfos = _.get(nextProps.invoice, 'subscribedAddOnsInfos', []);
    if (
      this.props.gettingInvoice === true &&
      gettingInvoice === false &&
      !_.isEmpty(nextSubscribedAddOnsInfos)
    ) {
      this.initAddonAdded(addonList, nextSubscribedAddOnsInfos);
    } else if (gettingInvoice === false && addonsSuggestionBeta.length > 0) {
      const preSelect = addonList.filter(listItem => {
        return addonsSuggestionBeta.includes(listItem.addonName);
      });
      this.setState({ addonAdded: preSelect, preSelect });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { addonAdded: addonAddedPrev = [], showDiscountCodeInput: showDiscountCodeInputPrev } =
      this.state;

    const { addonAdded = [], showDiscountCodeInput } = nextState;
    const { correctPlan: correctPlanPrev } = this.props;
    const { correctPlan, discount, remainCycles } = nextProps;

    if (
      (addonAdded.length !== addonAddedPrev.length ||
        correctPlanPrev !== correctPlan ||
        showDiscountCodeInput !== showDiscountCodeInputPrev) &&
      correctPlan
    ) {
      const invoice = calculateBillingMonthly(correctPlan, discount, addonAdded, remainCycles);
      this.setState({ invoice });
    }
  }

  renderDetailBill = (label, list, pkgName) => {
    const { i18n } = this.props;

    return (
      <div style={{ marginTop: '20px' }}>
        <TextStyle variation="strong">{label}</TextStyle>
        {list.map(({ name, title, price }, index) => (
          <div key={`${name}-renderBill-${index}`} className="detail-bill">
            <p>{i18n.translate(title)}</p>
            <TextStyle variation="strong">${formatPriceDisplay(price)}</TextStyle>
          </div>
        ))}
      </div>
    );
  };

  renderAddonOption = (infos, index) => {
    const { name = '', description = '', price = 0 } = infos;
    const { i18n } = this.props;

    return (
      <div key={`${name}-addonOption-${index}`} className="explore-addon-card">
        <div className="addon-card-price">
          {i18n.translate('AdminHTML.SubscriptionV4.Common.pricePerMonth', {
            price: price
          })}
        </div>
        <div>{i18n.translate(description)}</div>
      </div>
    );
  };

  render() {
    const {
      showDiscountCodeInput,
      addonAdded,
      addonList,
      invoice,
      code,
      subscribing,
      viewDiscountBreakdown
    } = this.state;
    const {
      active,
      i18n,
      verifying,
      packageInfo,
      discount: discountVerified = {},
      correctPlan = {},
      allowApplyDiscountCode,
      remainCycles,
      msgVerifyError
    } = this.props;
    const { title, name } = packageInfo;
    const { price = 0 } = correctPlan;
    const {
      total = price,
      originTotal = price,
      discountAmount = 0,
      expiredDate = '',
      discountDetail = []
    } = invoice;

    const discountType = _.get(discountVerified, 'discountType', 'percentage');
    const { dcRawValue, dcValue, dcPostfixValue } = getDiscountCodeValue(discountVerified);

    return (
      <Modal large open={active} onClose={this.handleCancel}>
        <div className="review-package-modal">
          <div className="review-package">
            <Scrollable style={{ maxHeight: '624px' }}>
              <div>{i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.title')}</div>
              <div>
                {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.subTitle', {
                  t1: (
                    <span className="link" onClick={() => this.goToSubscriptionPage()}>
                      {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.subTitle_t1')}
                      <Icon source={ExternalSmallMinor} />
                    </span>
                  )
                })}
              </div>
              {addonList.length > 0 && (
                <div>
                  <strong>
                    {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.labelAddon')}
                  </strong>
                </div>
              )}
              {/* Choice list addon */}
              <ChoiceList
                allowMultiple
                choices={addonList?.map((addon, index) => {
                  return {
                    label: i18n.translate(addon.title),
                    value: addon,
                    renderChildren: () => this.renderAddonOption(addon, index)
                  };
                })}
                selected={addonAdded}
                onChange={value => {
                  this.setState({ addonAdded: value });
                  // Re-Verify when update list addon
                  if (
                    !_.isEmpty(discountVerified) &&
                    _.get(discountVerified, 'scope', 'global') === 'add-on' &&
                    !value.length
                  ) {
                    this.clearDiscountCode();
                  }
                }}
              />
            </Scrollable>
          </div>
          <div className="package-billing">
            <div className="billing-title">
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.monthly')}
              </TextStyle>
              <Button onClick={this.handleCancel} plain icon={MobileCancelMajor} />
            </div>
            {/* Package info +  addon added */}
            <div className="package-info">
              {this.renderDetailBill(
                i18n.translate('AdminHTML.SubscriptionV4.PlanStatus.package'),
                [{ title, price }],
                name
              )}
              {addonAdded.length > 0 &&
                this.renderDetailBill(
                  i18n.translate('AdminHTML.SubscriptionV4.PlanStatus.addon'),
                  addonAdded,
                  name
                )}
            </div>
            {/* ---------------- */}
            {/* Discount code info */}
            <div className="discount-code-info">
              {code && dcValue ? (
                <div className="discount-applied">
                  <p>
                    {i18n.translate(
                      'AdminHTML.SubscriptionV4.ReviewPackage.textFieldDiscount_Label'
                    )}
                  </p>
                  <div className={`code`}>
                    <div>
                      <p>{code}</p>
                      <Button plain icon={MobileCancelMajor} onClick={this.clearDiscountCode} />
                    </div>
                    <TextStyle variation="strong">-${formatPriceDisplay(discountAmount)}</TextStyle>
                  </div>
                  <div>
                    {remainCycles &&
                      remainCycles > 0 &&
                      i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.discountPreview', {
                        duration: <strong>{remainCycles}</strong>,
                        totalInvoice: <strong>{formatPriceDisplay(total)}</strong>,
                        date: <strong>{expiredDate}</strong>,
                        originalPrice: <strong>{originTotal}</strong>
                      })}
                    {!viewDiscountBreakdown && discountType === 'percentage' && (
                      <div
                        style={{ color: '#2C6ECB', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({ viewDiscountBreakdown: true });
                        }}>
                        {i18n.translate('AdminHTML.SubscriptionV4.PlanStatus.seeDiscountBreakDown')}
                      </div>
                    )}
                    {viewDiscountBreakdown && discountType === 'percentage' && (
                      <>
                        <div>
                          {remainCycles > 0
                            ? i18n.translate(
                                'AdminHTML.SubscriptionV4.PlanStatus.discountInfo_Label',
                                { value: dcPostfixValue, duration: remainCycles }
                              )
                            : i18n.translate(
                                'AdminHTML.SubscriptionV4.PlanStatus.discountInfo_Label_Lifetime',
                                { value: dcPostfixValue }
                              )}
                        </div>
                        {discountDetail && (
                          <ul style={{ marginLeft: '-20px' }}>
                            {discountDetail.map(item => {
                              return (
                                <li key={item.name}>
                                  {i18n.translate(item.name)}
                                  <span className="discount-breakdown">
                                    -${formatPriceDisplay(item.price)}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    )}
                  </div>
                  <div>
                    <p>
                      {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.termAndCondition', {
                        t1: (
                          <span
                            onClick={this.handledTermNCondition}
                            style={{ color: '#2C6ECB', cursor: 'pointer' }}>
                            {i18n.translate(
                              'AdminHTML.SubscriptionV4.ReviewPackage.termAndCondition_t1'
                            )}
                          </span>
                        )
                      })}
                    </p>
                  </div>
                </div>
              ) : showDiscountCodeInput ? (
                <div>
                  <div className="discountCode">
                    <TextField
                      value={code}
                      label={i18n.translate(
                        'AdminHTML.SubscriptionV4.ReviewPackage.textFieldDiscount_Label'
                      )}
                      onChange={this.handleChangeCode}
                      placeholder={i18n.translate(
                        'AdminHTML.SubscriptionV4.Common.discountCodePlaceHolder'
                      )}
                      connectedRight={
                        <Button
                          primary
                          onClick={this.verify}
                          loading={verifying}
                          disabled={code ? false : true}>
                          {i18n.translate('AdminHTML.SubscriptionV4.ActionButton.apply')}
                        </Button>
                      }
                    />
                  </div>
                  {/* Code is not empty or dcRawValue > 0*/}
                  {showDiscountCodeInput && msgVerifyError && code && !dcRawValue && (
                    <div className={'applied error'}>
                      {DISCOUNT_ERRORS[msgVerifyError]
                        ? i18n.translate(DISCOUNT_ERRORS[msgVerifyError])
                        : msgVerifyError}
                    </div>
                  )}
                </div>
              ) : (
                allowApplyDiscountCode && (
                  <p
                    onClick={() => {
                      this.toggleModal('showDiscountCodeInput');
                    }}>
                    {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.addDiscount')}
                  </p>
                )
              )}
            </div>
            {/* ----------end---------- */}
            <div className="divider" />
            <div className="total">
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.SubscriptionV4.Common.total')}
              </TextStyle>
              <TextStyle variation="strong">${formatPriceDisplay(total)}</TextStyle>
            </div>
            <Button loading={subscribing} primary onClick={this.handleConfirm}>
              {i18n.translate('AdminHTML.SubscriptionV4.ReviewPackage.confirmAction')}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  // Handle init addon added
  initAddonAdded = (addonList, nextSubscribedAddOnsInfos) => {
    const preSelect = addonList.filter(listItem => {
      const matchingObj = nextSubscribedAddOnsInfos.find(subscribeAddon => {
        return subscribeAddon.addOnName === listItem.addonName && !subscribeAddon.cancelAt;
      });
      return matchingObj !== undefined;
    });
    this.setState({ addonAdded: preSelect, preSelect });
  };
  // Change discount code
  handleChangeCode = code => {
    this.setState({ code });
  };

  // Clear discount code
  clearDiscountCode = () => {
    const { clearDiscountCode } = this.props;
    // this.handleChangeCode('');
    this.setState({ showDiscountCodeInput: false, code: null, viewDiscountBreakdown: false });

    clearDiscountCode();
  };
  // Verify discount code
  verify = async () => {
    const { addonAdded, code } = this.state;
    const { verifyDiscountCode, correctPlan } = this.props;

    const addOns = addonAdded.map(addon => addon.addonName);
    const newPlanName = correctPlan?.name;
    await verifyDiscountCode(code, 'subscription-page', addOns, newPlanName).then(result => {
      if (result.type === 'VERIFY_DISCOUNT_CODE_SUCCESS') {
        const discountCode = _.get(result, 'payload.data.discount');
        const remainCycles = _.get(result, 'payload.data.remainCycles');
        const invoice = calculateBillingMonthly(
          correctPlan,
          discountCode,
          addonAdded,
          remainCycles
        );
        this.setState({ invoice });
      }
    });
  };

  // Close modal
  handleCancel = () => {
    this.clearDiscountCode();
    const { preSelect = [] } = this.state;
    // Clear all state
    this.setState({
      addonAdded: preSelect
    });
    this.props.handleCancel();
  };

  handledTermNCondition = value => {
    this.props.handledTermNCondition();
  };
  // Handle subscribe
  handleConfirm = () => {
    const { addonAdded = [], code } = this.state;
    const { discount } = this.props;
    const { dcRawValue } = getDiscountCodeValue(discount);
    const addonSubscribe = addonAdded.map(addon => addon.addonName);
    this.props.handleConfirm(addonSubscribe, dcRawValue > 0 ? code : null);
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  // Build addon list exclude add on in package
  buildAddonList = addonList => {
    const { packageInfo, useFreeVariant, packageNameType } = this.props;
    if (packageNameType === 'freemium') {
      this.setState({ addonList: [] });
      return;
    }

    const { addons = [] } = packageInfo;
    if (!addons || addons.length <= 0) return;
    addons.forEach(item => {
      _.remove(addonList, option => {
        return item === option.name;
      });
    });

    if (useFreeVariant) {
      _.remove(addonList, option => {
        return option.addonName === 'variant-display';
      });
    }
  };

  goToSubscriptionPage = () => {
    const { history } = this.props;
    history.push(routes.subscription.plan());
    this.handleCancel();
    exitSABFullscreen();
  };
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  return {
    tenantApp
  };
};

export default withI18n()(connect(mapStateToProps, null)(ReviewPackageModal));
